'use client';

import { Tooltip } from 'radix-ui';
import type { ReactNode } from 'react';

type Props = {
  /** Что подсказываем. Короткая строка, не абзац. */
  text: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
};

/**
 * Подсказка при наведении — вспомогательная мелочь для широкого экрана
 * (что делает значок в углу, почему кнопка недоступна).
 *
 * Только мышь (ТЗ WEB-LOOK Э4.6): на тач-экране браузера метка не рисуется вовсе — ни по
 * долгому тапу, ни по фокусу (`kit.css`, `@media (hover: none), (pointer: coarse)`).
 * Поэтому в подсказку не кладут ничего, без чего не обойтись на телефоне.
 *
 * INVARIANT(scriptera): пояснения к полям формы сюда НЕ прячут — они видимы всегда,
 * отдельной серой строкой под полем. Причина: пальцем наведения нет, и на телефоне
 * спрятанное пояснение недостижимо. Правило владельца, канон
 * docs/concepts/UI-TEMPLATE-CANON.md, раздел «Элементы формы».
 */
export function KTooltip({ text, children, side = 'top' }: Props) {
  return (
    <Tooltip.Provider delayDuration={280}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side={side} sideOffset={6} className="k k-tip">
            {text}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
